import { render } from "./StakingView.vue?vue&type=template&id=f3324364&ts=true"
import script from "./StakingView.vue?vue&type=script&lang=ts"
export * from "./StakingView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__